export const formatPrice = (priceInCents, activeLanguage) => {
  const options = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  let locale;
  if (activeLanguage === 'en') {
    locale = 'en-US';
  } else if (activeLanguage === 'es' || activeLanguage === 'fr') {
    locale = 'fr-FR';
  }

  const formattedPrice = (priceInCents / 100).toLocaleString(locale, options);

  return formattedPrice + '€';
}
